var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#3C5A99"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3145 100V65.7889H66.8129L68.5346 52.4562H55.3145V43.9441C55.3145 40.084 56.3879 37.4534 61.9306 37.4534L69 37.4504V25.5255C67.7774 25.363 63.5809 25 58.6986 25C48.506 25 41.5278 31.2134 41.5278 42.6237V52.4562H30V65.7889H41.5278V100H55.3145Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.d430c707b22c0fefd636e14e79e5eaeb.svg";
export { ForwardRef as ReactComponent };